export const UNCATEGORIZED_VALUE = 'uncategorized';

export function buildCategoryOptions(
  categories: { id: string | number; name: string }[],
  allLabel: string,
  uncategorizedLabel?: string
): { label: string; value: string }[] {
  if (categories.length < 2) {
    return [];
  }

  return [
    { label: allLabel, value: '' },
    ...categories.map((category) => ({
      label: category.name,
      value: String(category.id),
    })),
    ...(uncategorizedLabel ? [{ label: uncategorizedLabel, value: UNCATEGORIZED_VALUE }] : []),
  ];
}
